class PBXWebSocket {
  constructor() {
    this.ws = null;
    this.listeners = new Map();
    this.reconnectAttempts = 0;
    this.maxReconnects = 10;
    this.reconnectDelay = 2000;
    this.isConnecting = false;
  }

  connect(token) {
    if (this.ws?.readyState === WebSocket.OPEN || this.isConnecting) return;

    this.isConnecting = true;
    const wsProto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const wsUrl = process.env.REACT_APP_WS_URL || `${wsProto}://${window.location.host}/ws`;
    this.ws = new WebSocket(`${wsUrl}?token=${token}`);

    this.ws.onopen = () => {
      this.isConnecting = false;
      this.reconnectAttempts = 0;
      this.emit('connected');
    };

    this.ws.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        this.emit(msg.type, msg.data);
      } catch (_) {}
    };

    this.ws.onclose = () => {
      this.isConnecting = false;
      this.emit('disconnected');
      this._scheduleReconnect(token);
    };

    this.ws.onerror = () => {
      this.isConnecting = false;
    };
  }

  _scheduleReconnect(token) {
    if (this.reconnectAttempts >= this.maxReconnects) return;
    this.reconnectAttempts++;
    setTimeout(() => this.connect(token), this.reconnectDelay * this.reconnectAttempts);
  }

  on(event, callback) {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event).add(callback);
    return () => this.listeners.get(event)?.delete(callback);
  }

  emit(event, data) {
    this.listeners.get(event)?.forEach(cb => cb(data));
  }

  disconnect() {
    this.maxReconnects = 0;
    this.ws?.close();
  }
}

export const pbxWS = new PBXWebSocket();
